var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      class: ((_obj = {
        "b-loader": true
      }),
      (_obj["b-" + _vm.type] = true),
      (_obj["b-" + _vm.color] = true),
      (_obj["b-" + _vm.size] = true),
      _obj)
    },
    [_c("span")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }